export default {
  // filter_name : component file name
  dates_range: "ReportFilterDateRange",
  itinerary_dates: "ReportFilterItineraryDates",
  itinerary_creation_dates: "ReportFilterItineraryDates",
  first_invoiced_dates: "ReportFilterItineraryDates",
  invoice_creation_dates: "ReportFilterItineraryDates",
  agent_group_filter: "ReportFilterAgentGroup",
  agent_group: "ReportFilterAgentGroup",
  supplier: "ReportFilterSingleText",
  head_office: "ReportFilterHeadOffice",
  brands: "ReportFilterBrands",
  department_type_multi: "ReportFilterDepartmentTypes",
  department_type: "ReportFilterDepartmentType",
  dates: "ReportFilterItineraryDates",
  destination: "ReportFilterDestination",
  supplier_type: "ReportFilterSupplierType",
  supplier_type_multi: "ReportFilterSupplierTypeMulti",
  report_type: "ReportFilterReportType",
  itinerary_statuses: "ReportFilterItineraryStatuses",
  custom_fields: "ReportFilterAgentCustomFields",
  supplier_custom_fields: "ReportFilterSupplierCustomFields",
  client_custom_fields: "ReportFilterClientCustomFields",
  single_date: "ReportFilterSingleDate",
  direction: "ReportFilterDirection",
  client_info: "ReportFilterClientInfo",
  itinerary_ref: "ReportFilterSingleText",
  client_ref: "ReportFilterSingleText",
  itinerary_internal_ref: "ReportFilterSingleText",
  agent_region: "ReportFilterSingleText",
  booked_by: "ReportFilterSingleText",
  created_by: "ReportFilterSingleText",
  service: "ReportFilterSingleText",
  service_type: "ReportFilterSingleText",
  itinerary_internal_status: "ReportFilterInternalStatus",
  itinerary_internal_status_multi: "ReportFilterInternalStatusMulti",
  group_by: "ReportFilterGroupBy",
  publish: "ReportFilterPublish",
  destinations_and_agents: "ReportFilterDestination",
  excursions_field_type: "ReportFilterExcursionsFieldType",
  services_statuses: "ReportFilterServicesStatuses",
  service_status: "ReportFilterServicesStatuses",
  excursions_year: "ReportFilterExcursionsYear",
  lead_only: "ReportFilterSingleCheckbox",
  include_infant: "ReportFilterSingleCheckbox",
  include_child: "ReportFilterSingleCheckbox",
  include_adult: "ReportFilterSingleCheckbox",
  zero_prices: "ReportFilterSingleCheckbox",
  adjustments: "ReportFilterSingleCheckbox",
  base_currency_prices: "ReportFilterSingleCheckbox",
  service_qty: "ReportFilterSingleCheckbox",
  set_as_exported: "ReportFilterSingleCheckbox",
  not_in_use: "ReportFilterSingleCheckbox",
  only_show_used: "ReportFilterSingleCheckbox",
  report_details: "ReportFilterReportDetails",
  hotel_reconciliation_fields: "ReportFilterHotelReconciliationFields",
  itinerary_status: "ReportFilterItineraryStatus",
  invoice_status: "ReportFilterInvoiceStatus",
  invoice_exported: "ReportFilterInvoiceExported",
  additional_fields: "ReportFilterAdditionalFields",
  price_info: "ReportFilterPriceInfo",
  tour: "ReportFilterTour",
  supplier_chooser: "ReportFilterSupplierChooser",
  supplier_chooser_multi_type: "ReportFilterSupplierChooserMultiType",
  supplier_chooser_multi: "ReportFilterSupplierMultiChooser",
  agent_type_multi: "ReportFilterAgentTypeMulti",
  flight_no: "ReportFilterSingleText",
  note: "ReportFilterText",
  currency_filter: "ReportFilterCurrency",
};



// WEBPACK FOOTER //
// ./src/components/gt/reports/filters-map.js